import { HQ_LOCATION_PARSER } from './../../utils/location/location-parser';
import { AccountCarrierMapDTO } from './../../account/dtos/account-carrier-map-DTO';
import { CarrierTable } from './../views/carrier-table';
import { CarrierDTOResponse } from './../dtos/carrierDTOResponse';
import { IS_EMPTY, IS_NOT_EMPTY } from './../../utils/stringUtils/string-utils';
import { IS_NOT_NULL_OR_UNDEFINED } from './../../utils/commonUtils/validation-utils';
import { GET_CARRIER_BUSINESS_NAME } from './get-carrier-business-name';
import { Contacts } from './../../carrier/dtos/contacts';
import { ContactsTable } from './../../contact/views';
import { FULL_NAME } from './../../utils';
import { UserCarrierMap } from '../dtos/user-carrier-map';
import { Owner } from '../../project/dtos/owner';
import { DATE_MDY } from '../../utils/date/date-parser';
import { FORMAT_SCORE_PERCENTAGE } from './format-score-percentage';

export const CARRIER_LIST_TABLE = (
	carrierList: Array<CarrierDTOResponse> = [],
	accountId: number,
	userCarrierMaps?: UserCarrierMap[],
	usersList?: Owner[]
): Array<CarrierTable> => {
	let results: Array<CarrierTable> = [];
	try {
		if (carrierList.length > 0) {
			carrierList.map((carrier) => {
				let row = {} as CarrierTable;
				row.businessName = GET_CARRIER_BUSINESS_NAME(carrier.businessName, carrier.doingBusinessAs);
				row.carrierHQ = HQ_LOCATION_PARSER(carrier.city, carrier.state);
				row.customerCode = getCustomerCode(carrier.accountCarrierMaps, accountId);
				row.distance = IS_NOT_NULL_OR_UNDEFINED(carrier.distance)
					? Math.round(carrier.distance)
					: null;
				row.dot = carrier.dot;
				row.mc = carrier.mc;
				row.drivers = carrier.drivers;
				row.powerUnits = carrier.powerUnits;
				row.customerCarrier = carrier.customerCarrier;
				row.id = carrier.id;
				row.active = carrier.active;
				row.hazmat = carrier.hazmat;
				row.hasTeams = carrier.hasTeams;
				row.hasTeamsUpdatedOn = carrier.hasTeamsUpdatedOn;
				row.cargoInsuranceAmount = carrier.cargoInsuranceAmount;
				if (IS_NOT_NULL_OR_UNDEFINED(carrier.contacts) && carrier.contacts.length > 0) {
					row.contactsTable = CONTACTS_TABLE(carrier.contacts[0]);
				} else {
					row.contactsTable = {} as ContactsTable;
				}
				row.carrierOnboardedOn = null;
				row.vettingSource = null;

				const accountCarrierMap = carrier?.accountCarrierMaps?.find(
					(acm) => acm.accountId === accountId
				);
				if (accountCarrierMap) {
					row.carrierOnboardedOn = accountCarrierMap.carrierOnboardedOn;
					row.vettingSource = accountCarrierMap.vettingSource;
					row.ccBookingRateDisplay = FORMAT_SCORE_PERCENTAGE(accountCarrierMap.ccBookingRate);
					row.ccEngagementRateDisplay = FORMAT_SCORE_PERCENTAGE(accountCarrierMap.ccEngagementRate);
					row.ccFalloffRateDisplay = FORMAT_SCORE_PERCENTAGE(accountCarrierMap.ccFalloffRate);
					row.ccTotalBookedLoads = accountCarrierMap.ccTotalBookedLoads;
					row.ccScore = accountCarrierMap.ccScore;
					row.vettingAuthorityDisplay = accountCarrierMap.vettingAuthorityDisplay;
					row.vettingInsuranceDisplay = accountCarrierMap.vettingInsuranceDisplay;
					row.vettingOperationsDisplay = accountCarrierMap.vettingOperationsDisplay;
					row.vettingSafetyDisplay = accountCarrierMap.vettingSafetyDisplay;
					row.vettingOtherDisplay = accountCarrierMap.vettingOtherDisplay;
					row.vettingOverallDisplay = accountCarrierMap.vettingOverallDisplay;
					row.infractionDetails = accountCarrierMap.infractionDetails;
					row.lastVettingTime = accountCarrierMap.lastVettingTime;
					row.vettingSourceId = accountCarrierMap.vettingSourceId;
				}
				if (IS_EMPTY(row.vettingOverallDisplay) && IS_NOT_EMPTY(carrier.vettingOverallDisplay)) {
					row.ccBookingRateDisplay = FORMAT_SCORE_PERCENTAGE(carrier.ccBookingRate);
					row.ccEngagementRateDisplay = FORMAT_SCORE_PERCENTAGE(carrier.ccEngagementRate);
					row.ccFalloffRateDisplay = FORMAT_SCORE_PERCENTAGE(carrier.ccFalloffRate);
					row.ccTotalBookedLoads = carrier.ccTotalBookedLoads;
					row.ccScore = carrier.ccScore;
					row.vettingAuthorityDisplay = carrier.vettingAuthorityDisplay;
					row.vettingInsuranceDisplay = carrier.vettingInsuranceDisplay;
					row.vettingOperationsDisplay = carrier.vettingOperationsDisplay;
					row.vettingSafetyDisplay = carrier.vettingSafetyDisplay;
					row.vettingOtherDisplay = carrier.vettingOtherDisplay;
					row.vettingOverallDisplay = carrier.vettingOverallDisplay;
					row.infractionDetails = carrier.infractionDetails;
					row.lastVettingTime = carrier.lastVettingTime;
				}
				if (userCarrierMaps?.length) {
					const userCarrierMap = userCarrierMaps.find((ucm) => ucm.carrierId === carrier.id);
					if (userCarrierMap) {
						row.userCarrierMap = userCarrierMap;
						if (usersList?.length) {
							const repAssigned = usersList?.find(
								(user) => user.userId == userCarrierMap.assigneeId
							);
							row.assignedRep = repAssigned;
							row.assignedRepName = repAssigned?.name;
						}
					}
				}
				if (!row.assignedRep) {
					row.assignedRepName = 'unassigned';
				}

				row.lanesCount = carrier.laneCount;
				row.contactsCount = carrier.contactCount;
				row.authorityGrantDate = carrier.authorityGrantDate
					? DATE_MDY(carrier.authorityGrantDate)
					: 'N/A';

				row.haulPayApproved = carrier.haulPayApproved;
				row.haulPayApprovedUpdatedAt = carrier.haulPayApprovedUpdatedAt;

				results.push(row);
			});
		}
	} catch (error) {
		console.log('CARRIER_LIST_TABLE error: ', error);
	}
	return results;
};

export const getCustomerCode = (
	accountCarrierMaps: Array<AccountCarrierMapDTO>,
	accountId: number
) => {
	if (
		accountCarrierMaps != undefined &&
		accountCarrierMaps != null &&
		accountCarrierMaps &&
		accountCarrierMaps.length > 0
	) {
		const accountCarrierMap = accountCarrierMaps.find(
			(accountCarrierMap) => accountCarrierMap.accountId == accountId
		);
		if (
			accountCarrierMap != undefined &&
			accountCarrierMap != null &&
			IS_NOT_EMPTY(accountCarrierMap.customerCode)
		) {
			return accountCarrierMap.customerCode;
		}
	}
};

const CONTACTS_TABLE = (contact: Contacts): ContactsTable => {
	const contactsTable = {} as ContactsTable;
	if (IS_NOT_NULL_OR_UNDEFINED(contact)) {
		contactsTable.firstName = contact.firstName;
		contactsTable.lastName = contact.lastName;
		contactsTable.emailAddress = contact.emailAddress;
		contactsTable.phone = contact.phone;
		contactsTable.fullName = FULL_NAME(contactsTable.firstName, contactsTable.lastName);
	}
	return contactsTable;
};
